import React from "react";

const ModelEvalutionDoc = () => {
  return (
    <div className='container'>
        <h1 className='text-light text-center'>Model Evalution</h1>
      <p className='text-light'>
        MLGui is a web-based platform that provides model evaluation
        capabilities for students and developers. The platform includes a
        variety of tools for evaluating machine learning models, such as metrics
        for accuracy, precision, recall, and more. This allows users to easily
        compare the performance of different models and evaluate the
        effectiveness of different parameters. Additionally, MLGui provides
        visualization tools that can help users understand the results of their
        model evaluations, such as confusion matrices and ROC curves. These
        tools can be especially useful for students and developers who are
        learning how to evaluate machine learning models, as they provide a
        clear and intuitive way to understand the results. Overall, MLGui's
        model evaluation capabilities make it a powerful and user-friendly tool
        for evaluating and comparing the performance of machine learning models.
      </p>
    </div>
  );
};

export default ModelEvalutionDoc;
